import { Alert, Platform } from 'react-native';
import { toCamelCaseLabel } from './camelCaseLabel';

type ConfirmActionOptions = {
  title: string;
  message: string;
  confirmText?: string;
  destructive?: boolean;
  onConfirm: () => void | Promise<void>;
};

export function confirmAction({
  title,
  message,
  confirmText = 'OK',
  destructive = false,
  onConfirm,
}: ConfirmActionOptions) {
  const heading = toCamelCaseLabel(title);
  const confirmLabel = toCamelCaseLabel(confirmText);
  if (Platform.OS === 'web') {
    // React Native Web implements Alert.alert as a no-op, so confirm buttons
    // never run. Use the browser dialog so the action is reachable on web.
    const browser = globalThis as unknown as {
      confirm?: (prompt: string) => boolean;
    };
    if (browser.confirm?.(`${heading}\n\n${message}`)) {
      Promise.resolve(onConfirm()).catch(() => undefined);
    }
    return;
  }

  Alert.alert(heading, message, [
    { text: 'Cancel', style: 'cancel' },
    {
      text: confirmLabel,
      style: destructive ? 'destructive' : 'default',
      onPress: () => {
        Promise.resolve(onConfirm()).catch(() => undefined);
      },
    },
  ]);
}
